import { FormattedMessage } from "react-intl";

import { Button } from "@ps-design-system/components/Button";
import { Text } from "@ps-design-system/components/Text";
import PsStack from "@ps-design-system/icons/PSStack/PsStack";

export const NotFoundPage = () => {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-mt-64">
      <a href="/">
        <PsStack width={120} height={120} />
      </a>
      <Text className="tw-mt-44" element="h2" typeface="headline-5-b">
        <FormattedMessage defaultMessage="Page not found" />
      </Text>
      <Button className="tw-mt-36" appearance="purple" href="/">
        <FormattedMessage defaultMessage="Go to Home" />
      </Button>
    </div>
  );
};
